export default __webpack_public_path__ + "static/media/Ballroll_00351.385ed4e0.png";